export default "__VITE_ASSET__3a48ecfc__"